import { useState } from "react";

interface FileViewerProps {
	file: string;
	type?: string;
	className?: string;
}

export function FileViewer({ file, type, className = "" }: FileViewerProps) {
	const [isError, setIsError] = useState(false);

	if (type?.includes("image")) {
		return (
			<div className={`flex items-center justify-center h-full ${className}`}>
				{!isError ? (
					<img
						src={file}
						alt="Document preview"
						className="max-w-full max-h-full object-contain"
						onError={() => setIsError(true)}
					/>
				) : (
					<div className="text-gray-500">Impossible d'afficher cette image</div>
				)}
			</div>
		);
	}

	return (
		<div className={`h-full ${className}`}>
			{!isError ? (
				<iframe
					src={file}
					title="Document Preview"
					className="w-full h-full border-0"
					onError={() => setIsError(true)}
				/>
			) : (
				<div className="flex items-center justify-center h-full text-gray-500">
					Impossible d'afficher ce type de fichier
				</div>
			)}
		</div>
	);
}
